// Opens/closes the Subsidiary Index overlay (site-header.hbs / subsidiary-index.hbs).
// Uses the `hidden` attribute, not inline styles, so CSS stays the single
// source of truth for how the overlay looks.

export default function indexOverlay() {
    const toggle = document.getElementById("index-toggle");
    const overlay = document.getElementById("index-overlay");

    if (!toggle || !overlay) {
        return;
    }

    toggle.addEventListener("click", () => {
        overlay.hidden = false;
    });

    overlay.querySelectorAll("[data-index-close]").forEach((el) => {
        el.addEventListener("click", () => {
            overlay.hidden = true;
        });
    });

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            overlay.hidden = true;
        }
    });
}
